import { useState } from 'react';

import { Button } from '../../ui/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from '../../ui/catalyst/dialog';

interface Source {
  url: string;
  title?: string;
}

interface SourceIndicatorProps {
  sources: Source[];
}

export const SourceIndicator = ({ sources }: SourceIndicatorProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!sources || sources.length === 0) {
    return null;
  }

  const handleOpenDialog = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDialogOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpenDialog}
        aria-label={`View ${sources.length} source${sources.length > 1 ? 's' : ''}`}
        title={`${sources.length} source${sources.length > 1 ? 's' : ''}`}
        className="inline-flex items-center justify-center bg-gray-100 text-gray-600 hover:text-gray-800 rounded-full font-medium text-xs min-w-5 h-5 transition-colors"
      >
        {sources.length}
      </button>

      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <DialogTitle>
          {sources.length} Source{sources.length > 1 ? 's' : ''}
        </DialogTitle>
        <DialogBody>
          <div className="space-y-3">
            {sources.map((source, index) => (
              <div key={index} className="p-3 border rounded border-gray-200">
                <div className="text-sm font-medium mb-1">
                  {source.title || `Source ${index + 1}`}
                </div>
                <a
                  href={source.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-600 hover:underline break-all"
                >
                  {source.url}
                </a>
              </div>
            ))}
          </div>
          <DialogActions>
            <Button onClick={() => setIsDialogOpen(false)}>Close</Button>
          </DialogActions>
        </DialogBody>
      </Dialog>
    </>
  );
};
